/**
 * Request status type. Values align with backend enum (numeric).
 * Legacy string/numeric values from the API are mapped to these in the API layer.
 */
export enum RequestStatusType {
    /** The request has been created but not yet sent to the recipient. */
    Draft = 100,
    /** The request invitation has been sent to the recipient. */
    Sent = 200,
    /** The recipient has opened and started the request. */
    Started = 300,
    /** The request is actively being processed. */
    InProgress = 400,
    /** The request is under manual or automated review. */
    UnderReview = 500,
    /** The request is pending a retry attempt. */
    PendingRetry = 600,
    /** A change has been requested on the submission. */
    ChangeRequested = 700,
    /** The request completed successfully. */
    Success = 1000,
    /** The request outcome was inconclusive and could not be determined. */
    Inconclusive = 2000,
    /** The request failed (e.g. payment failure). */
    Failed = 3000,
    /** The request completed with caution-level risk indicators (retry). */
    Retry = 4000,
    /** The request was identified as high risk (blocked). */
    Blocked = 5000,
    /** The request expired before being completed. */
    Expired = 6000,
    /** The request was canceled by the requester. */
    Canceled = 7000,
    /** The request was closed as incomplete (voided). */
    ClosedIncomplete = 7500,
    /** The request was rejected by the recipient. */
    Rejected = 8000,
    /** The request was reversed (e.g. refunded). */
    Reversed = 9000,
}
